<template>
  <component :is="tag">
    <template v-if="isList">
      <template v-for="v in computedListValue">
        {{v}} <br />
      </template>
    </template>
    <template v-else>
      {{value}}
    </template>
  </component>
</template>

<script lang="ts">
  import Vue from 'vue'
  import {ArrayHelper} from '~/helpers/arrayHelper'

  /**
   * Use for rendering as a list or not
   */
  export default Vue.extend({
    props: {
      tag: {
        type: String,
        default: 'div',
      },
      value: {
        type: [
          String,
          Array as () => string[],
        ],
      },
      listValue: {
        type: [
          String,
          Array as () => string[],
        ],
      },
      isList: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      computedListValue(): string[] {
        return ArrayHelper.wrap(this.listValue || this.value)
      },
    },
  })
</script>